import { create } from 'zustand';

interface ScrollState {
  manualScroll: boolean;
  pendingNaviClick: number | null;
  setManualScroll: (value: boolean) => void;
  setPendingNaviClick: (value: number | null) => void;
  resetScrollState: () => void;
}

const useScrollStore = create<ScrollState>(set => ({
  manualScroll: false,
  pendingNaviClick: null,
  setManualScroll: (value: boolean) => set({ manualScroll: value }),
  setPendingNaviClick: (value: number | null) =>
    set({ pendingNaviClick: value }),
  resetScrollState: () =>
    set({
      manualScroll: false,
      pendingNaviClick: null,
    }),
}));

export default useScrollStore;
